import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

const CONFLUENCE_EDITOR_CLIENT_ID_PREFIX = 'confluence-editor';

export const getConfluenceEditorClientId = (contentId: string): ClientId =>
	client(`${CONFLUENCE_EDITOR_CLIENT_ID_PREFIX}-${contentId}`);
